// Multi-language translations for Turkesa website
const translations = {
    pt: {
        // Header
        announcementBar: "Portes grátis em compras superiores a 150€",

        // Navigation
        navNew: "Novidades",
        navCollection: "Coleção",
        navBrands: "Marcas",
        navOutlet: "Outlet",

        // Hero
        heroTitle: "Experiência de Luxo em Cada Detalhe",
        heroSubtitle: "Coleção Premium 2024",
        btnShopNow: "COMPRAR AGORA",
        heroViewCollection: "Ver coleção",

        // Novidades Section
        novidadesTitle: "NOVIDADES",
        verTudo: "ver tudo",
        btnView: "VER",
        productSoldOut: "ESGOTADO",
        relatedTitle: "TAMBÉM VAIS GOSTAR",
        lastUnits: "ÚLTIMAS UNIDADES",

        // Brands Section
        brandsTitle: "A Nossa (Irresistível) Seleção de Marcas",

        // About Section
        aboutSubtitle: "From Turkesa with love",
        aboutTitle: "Turkesa Shop",
        aboutText1: "O nome \"Turkêsa\" surge da inspiração nos mares de cor azul turquesa. Transmite energia boa e transporta-nos para paisagens paradisíacas.",
        aboutText2: "O objetivo da nossa loja é proporcionar a todas as nossas clientes, a confiança, a beleza, o bem-estar e a força necessária para enfrentar o dia-a-dia. Todas as mulheres são bonitas quando se sentem bonitas. A Turkêsa faz-te sentir ainda mais bonita.",

        // Footer
        footerInfo: "Info",
        footerContactos: "Contactos",
        footerLojas: "Lojas físicas",
        footerGiftCard: "Gift card",
        footerFaq: "FAQ's",
        footerEnvios: "Envios",
        footerTrocas: "Trocas e devoluções",

        footerPoliticas: "Políticas",
        footerTermos: "Termos e condições",
        footerPrivacidade: "Política de Privacidade e Cookies",
        footerLitigios: "Resolução de Litígios",
        footerReclamacoes: "Livro de Reclamações",

        // Cookie Banner
        cookieMessage: 'Este website utiliza cookies para melhorar a sua experiência de navegação. Ao continuar a navegar, concorda com a nossa <a href="/pages/privacidade" style="color: var(--primary-color); text-decoration: underline;">Política de Privacidade e Cookies</a>.',
        cookieAccept: "Aceitar",
        cookieManage: "Gerir Cookies",

        footerApoio: "Apoio ao Cliente",
        footerHorario: "Ter-Sáb: 10:00–13:00 / 14:30–18:00 | Dom-Seg: Fechado",
        footerTelemovel: "Telemovel & Whatsapp: 938 066 928",
        footerChamada: "(Chamada para rede móvel nacional)",
        footerEmail: "Email: turkesashop@gmail.com",

        footerNewsletter: "Keep up with Turkesa",
        footerNewsletterText: "Subscreve a nossa newsletter e recebe todas as novidades e campanhas no teu email.",
        footerNome: "Nome",
        footerEmailPlaceholder: "Email",
        footerSubscribe: "SUBSCREVER",
        footerLegalText: "Este site está protegido pela Política de privacidade da hCaptcha e da hCaptcha e aplicam-se os Termos de serviço dos mesmos",

        footerSocial: "Redes sociais",
        footerCopyright: "© Todos os direitos reservados 2026 . Turkêsa Shop . Powered by",

        // Cart
        cartTitle: "Carrinho",
        cartEmpty: "O seu carrinho está vazio",
        cartSubtotal: "Subtotal",
        cartTotal: "Total:",
        cartCheckout: "Finalizar Compra",
        cartDiscountLabel: "Desconto",
        cartDiscountCodeLabel: "Código de desconto",
        cartDiscountPlaceholder: "Inserir código",
        cartDiscountApply: "Aplicar",
        cartDiscountRemove: "Remover",
        cartDiscountApplied: "Código aplicado",
        cartDiscountInvalid: "Código inválido",
        cartDiscountEmpty: "Insere um código",

        // Product Page
        productBreadcrumbInicio: "Início",
        productBreadcrumbMulher: "Mulher",
        productBreadcrumbVestidos: "Vestidos",
        productSize: "Tamanho",
        productSelectSize: "Selecione o tamanho",
        productQuantity: "Quantidade",
        productAddToCart: "Adicionar ao Carrinho",
        productDescription: "Descrição",
        productComposition: "Composição",
        productShipping1: "Entregas em 24h",
        productShipping2: "Portes grátis em compras superiores a 155€",
        productShipping3: "Trocas e devoluções no prazo de 14 dias",
        productPayments: "Pagamentos Seguros",

        // Login Page
        loginWelcome: "Bem-vinda",
        loginSubtitle: "Entre na sua conta para continuar",
        loginEmail: "Email",
        loginEmailPlaceholder: "seu@email.com",
        loginPassword: "Palavra-passe",
        loginRememberMe: "Lembrar-me",
        loginForgotPassword: "Esqueceu a palavra-passe?",
        loginButton: "Entrar",
        loginDivider: "ou entre com",
        loginSignupText: "Não tem conta?",
        loginSignupLink: "Criar conta",
        loginAlready: "Já tem sessão iniciada.",
        loginGoAccount: "Ir para a conta",
        loginLogout: "Terminar sessão",
        loginRecoverTitle: "Recuperar palavra-passe",
        loginRecoverSubtitle: "Enviaremos um email para redefinir a sua palavra-passe.",
        loginRecoverButton: "Enviar email",
        loginRecoverBack: "Voltar ao login",
        loginRecoverSuccess: "Enviámos um email com instruções para redefinir a sua palavra-passe.",
        loginRecoverCooldownPrefix: "Aguarde",
        loginRecoverCooldownSuffix: "para tentar novamente.",

        // Register Page
        registerTitle: "Criar conta",
        registerSubtitle: "Crie a sua conta para acompanhar encomendas.",
        registerFirstName: "Nome",
        registerLastName: "Apelido",
        registerEmail: "Email",
        registerEmailPlaceholder: "Email",
        registerPhone: "Telemóvel",
        registerPhonePlaceholder: "Número de telemóvel",
        registerPhoneHelp: "Usamos este numero para avisar quando a encomenda estiver pronta para levantamento.",
        registerPassword: "Palavra-passe",
        registerPasswordPlaceholder: "••••••••",
        registerPasswordConfirm: "Confirmar palavra-passe",
        registerDob: "Data de nascimento",
        registerDobHint: "Usamos apenas para oferecer o seu desconto de aniversário.",
        registerCriteria1: "Mínimo 8 caracteres",
        registerCriteria2: "Pelo menos um número",
        registerCriteria3: "Pelo menos uma letra maiúscula",
        registerCriteria4: "Pelo menos um caractere especial",
        registerPasswordMismatch: "As palavras-passe não coincidem",
        registerSubmit: "Criar conta",
        registerHaveAccount: "Já tenho conta.",
        registerLoginLink: "Entrar",
        registerEmailExistsTitle: "Este email já está associado a uma conta.",
        registerEmailExistsText: "Se a conta é sua, pode",
        registerEmailExistsCTA: "recuperar a palavra-passe aqui",

        // Account Page
        accountTitle: "Minha Conta",
        accountLogout: "Sair",
        accountPersonalInfo: "Informação Pessoal",
        accountNameLabel: "Nome",
        accountEmailLabel: "Email",
        accountOrdersTitle: "Encomendas",
        accountOrderStatusProcessing: "Em Processamento",
        accountOrderStatusPending: "Pendente",
        accountOrderStatusDelivered: "Entregue",
        accountOrderDateLabel: "Data:",
        accountOrderTotalLabel: "Total:",
        accountOrderDetailsLink: "Ver detalhes",
        accountNoOrders: "Sem encomendas registadas.",

        // Order Page
        orderBackToAccount: "Voltar à conta",
        orderTitle: "Encomenda",
        orderPlacedOn: "Feita em",
        orderBillingAddress: "Endereço de faturação",
        orderShippingAddress: "Endereço de envio",
        orderPaymentStatus: "Estado de pagamento",
        orderFulfillmentStatus: "Estado de envio",
        orderItemsTitle: "Produtos",
        orderProduct: "Produto",
        orderSku: "SKU",
        orderPrice: "Preço",
        orderQuantity: "Quantidade",
        orderLineTotal: "Total",
        orderSubtotal: "Subtotal",
        orderDiscount: "Desconto",
        orderShipping: "Envio",
        orderTax: "Taxas",
        orderTotal: "Total",
        orderNoShippingAddress: "Sem endereço de envio.",
        orderStatusPaid: "Pago",
        orderStatusPending: "Pendente",
        orderStatusAuthorized: "Autorizado",
        orderStatusPartiallyPaid: "Parcialmente pago",
        orderStatusPartiallyRefunded: "Parcialmente reembolsado",
        orderStatusRefunded: "Reembolsado",
        orderStatusVoided: "Anulado",
        orderStatusUnpaid: "Não pago",
        orderFulfillmentFulfilled: "Entregue",
        orderFulfillmentUnfulfilled: "Não enviado",
        orderFulfillmentPartial: "Parcialmente enviado",
        orderFulfillmentRestocked: "Reposto",

        // Checkout Page
        checkoutTitle: "Finalizar Compra",
        checkoutContactInfo: "Informação de Contacto",
        checkoutShippingInfo: "Informação de Envio",
        checkoutFirstName: "Nome",
        checkoutLastName: "Apelido",
        checkoutAddress: "Morada",
        checkoutCity: "Cidade",
        checkoutPostalCode: "Código Postal",
        checkoutCountry: "País",
        checkoutCountrySelect: "Selecione um país",
        checkoutPhone: "Telefone",
        checkoutPaymentMethod: "Método de Pagamento",
        checkoutCardName: "Nome no Cartão",
        checkoutCardInfo: "Informação do Cartão",
        checkoutOrderSummary: "Resumo da Encomenda",
        checkoutQuantity: "Quantidade",
        checkoutSubtotal: "Subtotal",
        checkoutShipping: "Envio",
        checkoutTotal: "Total",
        checkoutFree: "Grátis",
        checkoutSecurePayment: "Pagamento Seguro",
        checkoutFastDelivery: "Entrega Rápida",
        checkoutCompleteOrder: "Finalizar Compra",

        // Contacts Page
        contactsTitle: "Contactos",
        contactsHeroTitle: "NÃO ENCONTRASTE O QUE PROCURAVAS?",
        contactsHeroSubtitle: "QUALQUER QUE SEJA A TUA QUESTÃO, ESTAMOS AQUI PARA AJUDAR.",
        contactsPhone: "Telefone & WhatsApp",
        contactsEmail: "Email",
        contactsSchedule: "Horário de Atendimento",
        contactsScheduleLine1: "Terça a Sábado: 10:00–13:00 / 14:30–18:00",
        contactsScheduleLine2: "Domingo e Segunda: Fechado",
        contactsAddress: "Morada",
        contactsSocial: "Redes Sociais",
        contactsFormTitle: "Envie-nos uma mensagem",
        contactsName: "Nome",
        contactsSubject: "Assunto",
        contactsMessage: "Mensagem",
        contactsSend: "Enviar",

        // Stores Page
        storesTitle: "Lojas Físicas",
        storesSubtitle: "Visite-nos nas nossas lojas e descubra as nossas coleções",
        storesLisbon: "Lisboa - Centro",
        storesPorto: "Porto - Baixa",
        storesFaro: "Faro - Marina",
        storesEspinho: "Loja Espinho",

        // Gift Card Page
        giftCardTitle: "Gift Card Turkesa",
        giftCardSubtitle: "O presente perfeito para quem ama moda",
        giftCardHow: "Como funciona?",
        giftCardStep1: "Escolha o valor do seu Gift Card",
        giftCardStep2: "Personalize com uma mensagem especial",
        giftCardStep3: "Receba por email ou imprima em casa",
        giftCardStep4: "O destinatário pode usar online ou em loja",
        giftCardConditions: "Condições",
        giftCardCond1: "Válido por 12 meses após a compra",
        giftCardCond2: "Pode ser usado em múltiplas compras",
        giftCardCond3: "Não reembolsável",
        giftCardCond4: "Válido em todas as lojas e online",
        giftCardSelectValue: "Selecione o valor",
        giftCardRecipient: "Nome do destinatário",
        giftCardRecipientEmail: "Email do destinatário",
        giftCardMessage: "Mensagem (opcional)",
        giftCardDescription: "A melhor prenda que podes dar a alguém especial é aquela de escolha entre a seleção de marcas e produtos que a Turkêsa Shop tem à tua disposição.",
        giftCardSelect: "Selecionar",
        giftCardInstructions: "Escolhe a quantia do teu gift card, confirma o pagamento através do método que preferires e recebe-o no teu e-mail. Não te esqueças de dar uma visita aos nossos artigos para conheceres e partilhares em mão.",
        giftCardHowItWorksTitle: "Como funciona?",
        giftCardStep1Title: "Escolhe o valor",
        giftCardStep1Desc: "Seleciona a quantia do gift card que desejas oferecer, entre 30€ e 300€.",
        giftCardStep2Title: "Finaliza a compra",
        giftCardStep2Desc: "Completa o pagamento de forma segura com o método que preferires.",
        giftCardStep3Title: "Recebe por email",
        giftCardStep3Desc: "Receberás um email com o código único do gift card pronto a usar ou oferecer.",
        giftCardStep4Title: "Usa na loja",
        giftCardStep4Desc: "Aplica o código no checkout e o valor será automaticamente deduzido do total da compra.",
        giftCardNote: "Os nossos gift cards têm validade de 6 meses a partir da data de emissão e podem ser usados em qualquer produto da Turkêsa Shop.",

        // FAQ Page
        faqTitle: "Perguntas Frequentes",
        faqSubtitle: "Encontre respostas para as suas dúvidas",
        faqOrders: "Encomendas",
        faqPayments: "Pagamentos",
        faqShipping: "Envios",
        faqReturns: "Devoluções e Trocas",
        faqQ1: "Como é feito o pagamento de uma encomenda?",
        faqA1: "Aceitamos Cartão de Crédito/Débito (Visa, Mastercard, American Express), PayPal, Apple Pay e Google Pay.",
        faqQ2: "Para que países a Turkesa Store faz envios?",
        faqA2: "Fazemos envios para Portugal Continental, Ilhas, e países da Europa. Para envios internacionais, contacte-nos.",
        faqQ3: "Quanto custa a entrega de uma encomenda?",
        faqA3: "Os portes são grátis em compras superiores a 50€. Abaixo desse valor, custam 5€ para Portugal Continental.",
        faqQ4: "Quanto tempo demora a entrega de uma encomenda?",
        faqA4: "O prazo de entrega é de 1 a 2 dias úteis para Portugal Continental e 5 a 10 dias úteis para as Ilhas.",
        faqQ5: "Posso trocar ou devolver uma peça de roupa?",
        faqA5: "Sim, tem 14 dias para devolver ou trocar produtos. O artigo deve estar em perfeitas condições com etiquetas originais.",
        faqQ6: "Qual é a morada para a qual devo enviar a encomenda em caso de devolução?",
        faqA6: "Entre em contacto connosco por email e receberá instruções detalhadas com a morada e etiqueta de devolução.",
        faqQ7: "Quanto custa a troca ou devolução de uma encomenda?",
        faqA7: "Os custos de devolução são da responsabilidade do cliente. Em caso de troca, os portes do novo artigo são gratuitos.",
        faqQ8: "Posso trocar um produto?",
        faqA8: "Sim, aceitamos trocas dentro do prazo de 14 dias. O produto deve estar em perfeitas condições.",

        // Shipping Page
        shippingTitle: "Envios",
        shippingSubtitle: "Informações sobre prazos e custos de envio",
        shippingCostsTitle: "Custos de Envio",
        shippingDestination: "Destino",
        shippingCost: "Custo",
        shippingTime: "Prazo",
        shippingPortugal: "Portugal Continental",
        shippingFreeOver50: "Grátis acima de 50€",
        shippingIslands: "Ilhas (Açores e Madeira)",
        shippingEurope: "Europa",
        shippingInternational: "Resto do Mundo",
        shippingContact: "Contactar",
        shipping3to5: "3-5 dias úteis",
        shipping5to7: "5-7 dias úteis",
        shipping7to15: "7-15 dias úteis",
        shippingProcessingTitle: "Processamento de Encomendas",
        shippingProcessingText: "As encomendas são processadas de segunda a sexta-feira, das 10h às 18h. Encomendas realizadas ao fim de semana ou feriados serão processadas no próximo dia útil.",
        shippingProcessing1: "Encomendas até às 14h: enviadas no mesmo dia",
        shippingProcessing2: "Encomendas após as 14h: enviadas no dia seguinte",
        shippingProcessing3: "Receberá email de confirmação com número de rastreio",
        shippingTrackingTitle: "Rastreamento da Encomenda",
        shippingTrackingText: "Após o envio da sua encomenda, receberá um email com o número de rastreio para acompanhar o estado da entrega.",
        shippingIssuesTitle: "Problemas com a Entrega?",
        shippingIssuesText: "Se a sua encomenda não chegar no prazo previsto ou se houver algum problema com a entrega, entre em contacto connosco:",
        shippingPolicyTitle: "Política de envio",
        shippingPolicyIntro: "A Turkesa confia a entrega das suas encomendas a um serviço de transporte externo, procedendo ao envio do(s) produto(s) encomendado(s) nos dias e horários utilizados pela empresa de logística, para a morada de entrega indicada.",
        shippingPolicyDeliveryTime: "O tempo estimado para entrega das encomendas varia entre 1 a 2 dias úteis para encomendas com morada de entrega em Portugal continental e 5 a 10 dias úteis para encomendas com morada de entrega nos Arquipélagos dos Açores ou Madeira. Os prazos de envio podem variar em períodos, como a quadra natalícia.",
        shippingPolicyCosts: "Os custos aplicados ao envio da encomenda ficam a responsabilidade do cliente. O envio tem um custo variável, dependendo da encomenda, salvo encomendas de valor igual ou superior a 155 € nas quais os portes de envio são gratuitos, assumidos pela Turkesa.",
        shippingPolicyResponsibility: "A Turkesa não se responsabiliza por qualquer custo associado a possíveis desalfandegamentos, ficando os mesmos ao encargo do cliente.",
        shippingPolicyChecking: "O cliente é responsável por verificar o(s) produto(s) encomendado(s), bem como proceder ao reembolso do montante pago, no prazo máximo de 15 (quinze) dias úteis após a receção do conhecimento da indisponibilidade.",
        shippingPolicyConfirmation: "A entrega considera-se efetuada com a assinatura no recibo de entrega na morada acordada.",

        // Returns Page
        returnsTitle: "Trocas e Devoluções",
        returnsSubtitle: "A sua satisfação é a nossa prioridade",
        returnsPolicyTitle: "Trocas e Devoluções",
        returnsPolicyIntro: "O cliente poderá proceder à troca do(s) artigo(s) 14 dias após a receção dos mesmos.",
        returnsPolicyConditions: "Desde que,",
        returnsPolicyCondition1: "Os produtos não tenham sido utilizados;",
        returnsPolicyCondition2: "Com as devidas etiquetas.",
        returnsPolicyShippingCost: "O custo do envio da devolução é a cargo do cliente.",
        returnsPolicyRefundNote: "Note que, caso a devolução seja feita por outros motivos que não conformidade dos produtos encomendados, a Turkêsa não efetuará o reembolso dos portes de envio.",
        returnsPolicyIdentification: "Deve ainda colocar a sua identificação na encomenda devolvida, de forma a Turkêsa analisar o estado de conservação dos artigos, e após análise, entrar em contacto com o cliente.",
        returnsPolicyNote: "Nota:",
        returnsPolicyDefect: "Em caso de defeito, o valor dos portes é suportado até ao valor de 5€.",
        returnsPolicyReservations: "Não efetuamos reservas.",

        // Terms Page
        termsTitle: "Termos e Condições",
        termsLastUpdated: "Última atualização: Fevereiro 2026",
        termsSection1Title: "1. Informações Gerais",
        termsSection1Body: "Bem-vindo à Turkesa. Ao aceder e utilizar este website, aceita estar vinculado a estes Termos e Condições. Se não concordar com alguma parte destes termos, não deverá utilizar o nosso website.",
        termsSection2Title: "2. Informações da Empresa",
        termsCompanyNameLabel: "Nome:",
        termsCompanyAddressLabel: "Morada:",
        termsCompanyEmailLabel: "Email:",
        termsCompanyPhoneLabel: "Telefone:",
        termsSection3Title: "3. Produtos e Preços",
        termsSection3Item1: "Todos os produtos estão sujeitos a disponibilidade",
        termsSection3Item2: "Os preços apresentados incluem IVA à taxa legal em vigor",
        termsSection3Item3: "Reservamos o direito de alterar preços sem aviso prévio",
        termsSection3Item4: "As imagens dos produtos são meramente ilustrativas",
        termsSection3Item5: "Os produtos podem apresentar ligeiras variações de cor devido às configurações do seu monitor",
        termsSection4Title: "4. Processo de Encomenda",
        termsSection4Intro: "Ao fazer uma encomenda, o cliente:",
        termsSection4Item1: "Confirma que todos os dados fornecidos são verdadeiros e corretos",
        termsSection4Item2: "Aceita os presentes Termos e Condições",
        termsSection4Item3: "Autoriza a Turkesa a processar os seus dados pessoais",
        termsSection4Item4: "Recebe um email de confirmação da encomenda",
        termsSection5Title: "5. Pagamento",
        termsSection5Intro: "Aceitamos os seguintes métodos de pagamento:",
        termsSection5Item1: "Cartão de Crédito/Débito (Visa, Mastercard)",
        termsSection5Item2: "PayPal",
        termsSection5Item3: "Apple Pay",
        termsSection5Item4: "Transferência Bancária",
        termsSection5Outro: "O pagamento deve ser efetuado no momento da encomenda. A encomenda só será processada após a confirmação do pagamento.",
        termsSection6Title: "6. Envios e Entregas",
        termsSection6Item1: "Portes grátis em compras superiores a 150€",
        termsSection6Item2: "Prazo de entrega: 2-5 dias úteis (Portugal Continental)",
        termsSection6Item3: "As entregas são efetuadas de segunda a sexta-feira",
        termsSection6Item4: "É necessário que haja alguém no local para receber a encomenda",
        termsSection6Item5: "Em caso de ausência, será deixado um aviso para recolha",
        termsSection7Title: "7. Direito de Livre Resolução",
        termsSection7Body1: "De acordo com a legislação portuguesa, o cliente tem direito a devolver a encomenda no prazo de 14 dias após a receção, sem necessidade de justificação.",
        termsSection7Body2: "Condições para exercer este direito:",
        termsSection7Body3: "Quando o cliente devolver o artigo, tem de escrever/indicar o número de rastreio que a transportadora forneceu, para que possamos identificar a encomenda devolvida.",
        termsSection7Item1: "Os produtos devem estar em perfeito estado",
        termsSection7Item2: "Com etiquetas e embalagem original",
        termsSection7Item3: "Não podem ter sido usados ou lavados",
        termsSection7Item4: "O custo de devolução é da responsabilidade do cliente",
        termsSection8Title: "8. Garantias",
        termsSection8Body1: "Todos os produtos comercializados beneficiam de garantia legal de 2 anos, de acordo com o Decreto-Lei nº 67/2003.",
        termsSection8Body2: "Em caso de defeito de fabrico:",
        termsSection8Item1: "Contacte-nos através do email turkesashop@gmail.com",
        termsSection8Item2: "Descreva o problema e envie fotografias se possível",
        termsSection8Item3: "Aguarde instruções para devolução ou reparação",
        termsSection9Title: "9. Propriedade Intelectual",
        termsSection9Body: "Todos os conteúdos deste website, incluindo textos, imagens, logótipos e design, são propriedade da Turkesa e estão protegidos por direitos de autor. É proibida a reprodução sem autorização prévia.",
        termsSection10Title: "10. Limitação de Responsabilidade",
        termsSection10Intro: "A Turkesa não se responsabiliza por:",
        termsSection10Item1: "Atrasos nas entregas causados por transportadoras",
        termsSection10Item2: "Danos causados por uso inadequado dos produtos",
        termsSection10Item3: "Indisponibilidade temporária do website",
        termsSection10Item4: "Erros tipográficos ou de informação",
        termsSection11Title: "11. Proteção de Dados",
        termsSection11Body: "A recolha e tratamento de dados pessoais está descrita na nossa Política de Privacidade. Ao utilizar este website, consente o tratamento dos seus dados conforme descrito.",
        termsSection12Title: "12. Resolução de Litígios",
        termsSection12Body: "Em caso de litígio, o cliente pode recorrer a uma Entidade de Resolução Alternativa de Litígios de consumo. Para mais informações, consulte a nossa página de Resolução de Litígios.",
        termsSection13Title: "13. Lei Aplicável",
        termsSection13Body: "Estes Termos e Condições são regidos pela lei portuguesa. Qualquer litígio será da competência dos tribunais portugueses.",
        termsSection14Title: "14. Alterações aos Termos",
        termsSection14Body: "A Turkesa reserva-se o direito de modificar estes Termos e Condições a qualquer momento. As alterações entrarão em vigor imediatamente após a sua publicação no website.",
        termsSection15Title: "15. Contactos",
        termsSection15Body: "Para qualquer questão relacionada com estes Termos e Condições, contacte-nos:",
        termsSection15ItemEmailLabel: "Email:",
        termsSection15ItemPhoneLabel: "Telefone/WhatsApp:",
        termsSection15ItemAddressLabel: "Morada:",

        // Privacy Page
        privacyTitle: "Política de Privacidade e Cookies",
        privacyLastUpdated: "Última atualização: Janeiro 2026",
        privacySection1Title: "1. Introdução",
        privacySection1Body: "A Turkesa respeita a sua privacidade e está comprometida em proteger os seus dados pessoais. Esta Política de Privacidade explica como recolhemos, usamos, armazenamos e protegemos as suas informações quando visita o nosso website ou utiliza os nossos serviços.",
        privacySection2Title: "2. Dados Que Recolhemos",
        privacySection2Intro: "Podemos recolher e processar os seguintes dados pessoais:",
        privacySection2Item1: "Informações de identificação (nome, email, número de telefone)",
        privacySection2Item2: "Morada de entrega e faturação",
        privacySection2Item3: "Informações de pagamento (processadas de forma segura)",
        privacySection2Item4: "Histórico de compras e preferências",
        privacySection2Item5: "Dados de navegação (endereço IP, tipo de navegador, páginas visitadas)",
        privacySection3Title: "3. Como Utilizamos os Seus Dados",
        privacySection3Intro: "Utilizamos os seus dados pessoais para:",
        privacySection3Item1: "Processar e entregar as suas encomendas",
        privacySection3Item2: "Comunicar sobre o estado das suas encomendas",
        privacySection3Item3: "Melhorar a sua experiência de compra",
        privacySection3Item4: "Enviar newsletters e ofertas promocionais (com o seu consentimento)",
        privacySection3Item5: "Cumprir obrigações legais",
        privacySection4Title: "4. Cookies",
        privacySection4Intro: "O nosso website utiliza cookies para melhorar a sua experiência de navegação. Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo que nos ajudam a:",
        privacySection4Item1: "Recordar as suas preferências e definições",
        privacySection4Item2: "Manter a sua sessão de login",
        privacySection4Item3: "Analisar o tráfego do website",
        privacySection4Item4: "Personalizar o conteúdo e anúncios",
        privacySection4Outro: "Pode gerir as suas preferências de cookies através das definições do seu navegador.",
        privacySection5Title: "5. Partilha de Dados",
        privacySection5Intro: "A Turkesa não vende os seus dados pessoais a terceiros. Podemos partilhar as suas informações com:",
        privacySection5Item1: "Prestadores de serviços de pagamento",
        privacySection5Item2: "Empresas de transporte e entrega",
        privacySection5Item3: "Fornecedores de serviços de tecnologia",
        privacySection5Outro: "Todas estas entidades estão obrigadas a proteger os seus dados e utilizá-los apenas para os fins especificados.",
        privacySection6Title: "6. Segurança dos Dados",
        privacySection6Body: "Implementamos medidas de segurança técnicas e organizacionais para proteger os seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição.",
        privacySection7Title: "7. Os Seus Direitos",
        privacySection7Intro: "De acordo com o RGPD, tem direito a:",
        privacySection7Item1: "Aceder aos seus dados pessoais",
        privacySection7Item2: "Retificar dados incorretos ou incompletos",
        privacySection7Item3: "Solicitar a eliminação dos seus dados",
        privacySection7Item4: "Opor-se ao processamento dos seus dados",
        privacySection7Item5: "Solicitar a portabilidade dos seus dados",
        privacySection7Item6: "Retirar o consentimento a qualquer momento",
        privacySection8Title: "8. Retenção de Dados",
        privacySection8Body: "Mantemos os seus dados pessoais apenas pelo tempo necessário para cumprir os objetivos descritos nesta política ou conforme exigido por lei.",
        privacySection9Title: "9. Contacto",
        privacySection9Intro: "Para questões sobre esta Política de Privacidade ou para exercer os seus direitos, contacte-nos:",
        privacySection9ItemEmailLabel: "Email:",
        privacySection9ItemPhoneLabel: "Telefone:",
        privacySection9ItemAddressLabel: "Morada:",
        privacySection10Title: "10. Alterações a Esta Política",
        privacySection10Body: "Reservamos o direito de atualizar esta Política de Privacidade periodicamente. Quaisquer alterações serão publicadas nesta página com a data de atualização.",

        // Dispute Resolution Page
        litigiosTitle: "Resolução Alternativa de Litígios",
        litigiosSection1Title: "Informação ao Consumidor",
        litigiosSection1Body: "De acordo com o disposto na Lei n.º 144/2015, de 8 de setembro, informamos que, em caso de litígio, o consumidor pode recorrer a uma Entidade de Resolução Alternativa de Litígios de consumo.",
        litigiosSection2Title: "O que é a Resolução Alternativa de Litígios?",
        litigiosSection2Body: "A Resolução Alternativa de Litígios (RAL) é um procedimento extrajudicial que permite aos consumidores e comerciantes resolverem os seus conflitos de forma simples, rápida, informal e gratuita ou de baixo custo.",
        litigiosSection3Title: "Como funciona?",
        litigiosSection3Body: "Em caso de litígio, o consumidor pode apresentar a sua reclamação junto de uma das entidades de resolução alternativa de litígios de consumo. Estas entidades são imparciais e podem ajudar na resolução do conflito através de mediação, conciliação ou arbitragem.",
        litigiosSection4Title: "Entidades de Resolução Alternativa de Litígios",
        litigiosSection4Intro: "Para mais informações, consulte o Portal do Consumidor em:",
        litigiosSection4SubTitle: "Principais Entidades RAL em Portugal:",
        litigiosLabelWebsite: "Website:",
        litigiosLabelEmail: "Email:",
        litigiosLabelPhone: "Telefone:",
        litigiosSection5Title: "Plataforma Europeia de Resolução de Litígios Online",
        litigiosSection5Body: "Para litígios transfronteiriços, os consumidores podem recorrer à Plataforma Europeia de Resolução de Litígios Online:",
        litigiosSection6Title: "Livro de Reclamações",
        litigiosSection6Body: "Pode também apresentar a sua reclamação através do Livro de Reclamações Eletrónico:",
        litigiosSection7Title: "Contacte-nos Primeiro",
        litigiosSection7Body: "Antes de recorrer a uma entidade de resolução de litígios, recomendamos que entre em contacto connosco para tentarmos resolver amigavelmente qualquer questão:",
        litigiosSection7ItemEmailLabel: "Email:",
        litigiosSection7ItemPhoneLabel: "Telefone/WhatsApp:",
        litigiosSection7ItemAddressLabel: "Morada:",
        litigiosSection7Closing: "Estamos comprometidos em resolver qualquer problema de forma rápida e satisfatória.",

        // Discount Popup
        popupQuestion: "Queres",
        popupDiscount: "5% OFF",
        popupSubtitle: "Na tua primeira compra",
        popupEmailPlaceholder: "Insere o teu email",
        popupButtonYes: "Quero os meus 5%",
        popupButtonNo: "Não, obrigado",
        popupSuccess: "Desconto aplicado no checkout.",

        // Search Modal
        searchTitle: "O que procura?",
        searchPlaceholder: "Pesquisar produtos...",
        searchButton: "Pesquisar",
        searchPageTitle: "Pesquisa de produtos",
        searchPageSubtitle: "Encontra os produtos que procuras.",
        searchResultsLabel: "Resultados",
        searchResultsFor: "Resultados para",
        searchNoResultsTitle: "Nenhum produto encontrado",
        searchNoResultsText: "Não encontrámos produtos para",
        searchNoResultsHint: "Tenta outro termo ou verifica a ortografia.",
        searchStartTitle: "Começa a pesquisar",
        searchStartText: "Escreve o nome de um produto para começar."
    },

    en: {
        // Header
        announcementBar: "Free shipping on orders over €150",

        // Navigation
        navNew: "New",
        navCollection: "Collection",
        navBrands: "Brands",
        navOutlet: "Outlet",

        // Hero
        heroTitle: "Experience Luxury in Every Detail",
        heroSubtitle: "Premium Collection 2024",
        btnShopNow: "SHOP NOW",
        heroViewCollection: "View collection",

        // Novidades Section
        novidadesTitle: "NEW ARRIVALS",
        verTudo: "view all",
        btnView: "VIEW",
        productSoldOut: "SOLD OUT",
        relatedTitle: "YOU MAY ALSO LIKE",
        lastUnits: "LAST UNITS",

        // Brands Section
        brandsTitle: "Our (Irresistible) Selection of Brands",

        // About Section
        aboutSubtitle: "From Turkesa with love",
        aboutTitle: "Turkesa Shop",
        aboutText1: "The name \"Turkêsa\" comes from the inspiration of turquoise blue seas. It transmits good energy and transports us to paradisiacal landscapes.",
        aboutText2: "The goal of our store is to provide all our clients with confidence, beauty, well-being, and the necessary strength to face everyday life. All women are beautiful when they feel beautiful. Turkêsa makes you feel even more beautiful.",

        // Footer
        footerInfo: "Info",
        footerContactos: "Contact",
        footerLojas: "Physical Stores",
        footerGiftCard: "Gift card",
        footerFaq: "FAQ's",
        footerEnvios: "Shipping",
        footerTrocas: "Returns & Exchanges",

        footerPoliticas: "Policies",
        footerTermos: "Terms and conditions",
        footerPrivacidade: "Privacy Policy and Cookies",
        footerLitigios: "Dispute Resolution",
        footerReclamacoes: "Complaints Book",

        // Cookie Banner
        cookieMessage: 'This website uses cookies to improve your browsing experience. By continuing to browse, you agree to our <a href="/pages/privacidade" style="color: var(--primary-color); text-decoration: underline;">Privacy and Cookies Policy</a>.',
        cookieAccept: "Accept",
        cookieManage: "Manage Cookies",

        footerApoio: "Customer Support",
        footerHorario: "Tue-Sat: 10:00–13:00 / 14:30–18:00 | Sun-Mon: Closed",
        footerTelemovel: "Mobile & Whatsapp: 938 066 928",
        footerChamada: "(Call to national mobile network)",
        footerEmail: "Email: turkesashop@gmail.com",

        footerNewsletter: "Keep up with Turkesa",
        footerNewsletterText: "Subscribe to our newsletter and receive all news and campaigns in your email.",
        footerNome: "Name",
        footerEmailPlaceholder: "Email",
        footerSubscribe: "SUBSCRIBE",
        footerLegalText: "This site is protected by hCaptcha's Privacy Policy and hCaptcha and its Terms of Service apply",

        footerSocial: "Social Media",
        footerCopyright: "© All rights reserved 2026 . Turkêsa Shop . Powered by",

        // Cart
        cartTitle: "Cart",
        cartEmpty: "Your cart is empty",
        cartSubtotal: "Subtotal",
        cartTotal: "Total:",
        cartCheckout: "Checkout",
        cartDiscountLabel: "Discount",
        cartDiscountCodeLabel: "Discount code",
        cartDiscountPlaceholder: "Enter code",
        cartDiscountApply: "Apply",
        cartDiscountRemove: "Remove",
        cartDiscountApplied: "Code applied",
        cartDiscountInvalid: "Invalid code",
        cartDiscountEmpty: "Enter a code",

        // Product Page
        productBreadcrumbInicio: "Home",
        productBreadcrumbMulher: "Women",
        productBreadcrumbVestidos: "Dresses",
        productSize: "Size",
        productSelectSize: "Select size",
        productQuantity: "Quantity",
        productAddToCart: "Add to Cart",
        productDescription: "Description",
        productComposition: "Composition",
        productShipping1: "24h delivery",
        productShipping2: "Free shipping on orders over €155",
        productShipping3: "Returns and exchanges within 14 days",
        productPayments: "Secure Payments",

        // Login Page
        loginWelcome: "Welcome",
        loginSubtitle: "Sign in to your account to continue",
        loginEmail: "Email",
        loginEmailPlaceholder: "your@email.com",
        loginPassword: "Password",
        loginRememberMe: "Remember me",
        loginForgotPassword: "Forgot your password?",
        loginButton: "Sign In",
        loginDivider: "or sign in with",
        loginSignupText: "Don't have an account?",
        loginSignupLink: "Create account",
        loginAlready: "You are already signed in.",
        loginGoAccount: "Go to account",
        loginLogout: "Log out",
        loginRecoverTitle: "Reset your password",
        loginRecoverSubtitle: "We'll email you a link to reset your password.",
        loginRecoverButton: "Send email",
        loginRecoverBack: "Back to login",
        loginRecoverSuccess: "We've sent you an email with instructions to reset your password.",
        loginRecoverCooldownPrefix: "Please wait",
        loginRecoverCooldownSuffix: "before trying again.",

        // Register Page
        registerTitle: "Create account",
        registerSubtitle: "Create your account to follow orders.",
        registerFirstName: "First name",
        registerLastName: "Last name",
        registerEmail: "Email",
        registerEmailPlaceholder: "Email",
        registerPhone: "Mobile phone",
        registerPhonePlaceholder: "Mobile number",
        registerPhoneHelp: "We use this number to notify you when your order is ready for pickup.",
        registerPassword: "Password",
        registerPasswordPlaceholder: "••••••••",
        registerPasswordConfirm: "Confirm password",
        registerDob: "Date of birth",
        registerDobHint: "Only used to send your birthday discount.",
        registerCriteria1: "Minimum 8 characters",
        registerCriteria2: "At least one number",
        registerCriteria3: "At least one uppercase letter",
        registerCriteria4: "At least one special character",
        registerPasswordMismatch: "Passwords do not match",
        registerSubmit: "Create account",
        registerHaveAccount: "I already have an account.",
        registerLoginLink: "Sign in",
        registerEmailExistsTitle: "This email is already associated with an account.",
        registerEmailExistsText: "If this account is yours, you can",
        registerEmailExistsCTA: "reset your password here",

        // Account Page
        accountTitle: "My Account",
        accountLogout: "Log out",
        accountPersonalInfo: "Personal Information",
        accountNameLabel: "Name",
        accountEmailLabel: "Email",
        accountOrdersTitle: "Orders",
        accountOrderStatusProcessing: "Processing",
        accountOrderStatusPending: "Pending",
        accountOrderStatusDelivered: "Delivered",
        accountOrderDateLabel: "Date:",
        accountOrderTotalLabel: "Total:",
        accountOrderDetailsLink: "View details",
        accountNoOrders: "No orders yet.",

        // Order Page
        orderBackToAccount: "Back to account",
        orderTitle: "Order",
        orderPlacedOn: "Placed on",
        orderBillingAddress: "Billing address",
        orderShippingAddress: "Shipping address",
        orderPaymentStatus: "Payment status",
        orderFulfillmentStatus: "Fulfillment status",
        orderItemsTitle: "Products",
        orderProduct: "Product",
        orderSku: "SKU",
        orderPrice: "Price",
        orderQuantity: "Quantity",
        orderLineTotal: "Total",
        orderSubtotal: "Subtotal",
        orderDiscount: "Discount",
        orderShipping: "Shipping",
        orderTax: "Tax",
        orderTotal: "Total",
        orderNoShippingAddress: "No shipping address.",
        orderStatusPaid: "Paid",
        orderStatusPending: "Pending",
        orderStatusAuthorized: "Authorized",
        orderStatusPartiallyPaid: "Partially paid",
        orderStatusPartiallyRefunded: "Partially refunded",
        orderStatusRefunded: "Refunded",
        orderStatusVoided: "Voided",
        orderStatusUnpaid: "Unpaid",
        orderFulfillmentFulfilled: "Fulfilled",
        orderFulfillmentUnfulfilled: "Unfulfilled",
        orderFulfillmentPartial: "Partially fulfilled",
        orderFulfillmentRestocked: "Restocked",

        // Checkout Page
        checkoutTitle: "Checkout",
        checkoutContactInfo: "Contact Information",
        checkoutShippingInfo: "Shipping Information",
        checkoutFirstName: "First Name",
        checkoutLastName: "Last Name",
        checkoutAddress: "Address",
        checkoutCity: "City",
        checkoutPostalCode: "Postal Code",
        checkoutCountry: "Country",
        checkoutCountrySelect: "Select a country",
        checkoutPhone: "Phone",
        checkoutPaymentMethod: "Payment Method",
        checkoutCardName: "Name on Card",
        checkoutCardInfo: "Card Information",
        checkoutOrderSummary: "Order Summary",
        checkoutQuantity: "Quantity",
        checkoutSubtotal: "Subtotal",
        checkoutShipping: "Shipping",
        checkoutTotal: "Total",
        checkoutFree: "Free",
        checkoutSecurePayment: "Secure Payment",
        checkoutFastDelivery: "Fast Delivery",
        checkoutCompleteOrder: "Complete Order",

        // Contacts Page
        contactsTitle: "Contacts",
        contactsHeroTitle: "DIDN'T FIND WHAT YOU WERE LOOKING FOR?",
        contactsHeroSubtitle: "WHATEVER YOUR QUESTION IS, WE'RE HERE TO HELP.",
        contactsPhone: "Phone & WhatsApp",
        contactsEmail: "Email",
        contactsSchedule: "Opening Hours",
        contactsScheduleLine1: "Tuesday to Saturday: 10:00–13:00 / 14:30–18:00",
        contactsScheduleLine2: "Sunday and Monday: Closed",
        contactsAddress: "Address",
        contactsSocial: "Social Media",
        contactsFormTitle: "Send us a message",
        contactsName: "Name",
        contactsSubject: "Subject",
        contactsMessage: "Message",
        contactsSend: "Send",

        // Stores Page
        storesTitle: "Physical Stores",
        storesSubtitle: "Visit our stores and discover our collections",
        storesLisbon: "Lisbon - Downtown",
        storesPorto: "Porto - Downtown",
        storesFaro: "Faro - Marina",
        storesEspinho: "Espinho Store",

        // Gift Card Page
        giftCardTitle: "Turkesa Gift Card",
        giftCardSubtitle: "The perfect gift for fashion lovers",
        giftCardHow: "How does it work?",
        giftCardStep1: "Choose your Gift Card amount",
        giftCardStep2: "Personalize with a special message",
        giftCardStep3: "Receive by email or print at home",
        giftCardStep4: "Recipient can use online or in-store",
        giftCardConditions: "Conditions",
        giftCardCond1: "Valid for 12 months after purchase",
        giftCardCond2: "Can be used in multiple purchases",
        giftCardCond3: "Non-refundable",
        giftCardCond4: "Valid in all stores and online",
        giftCardSelectValue: "Select amount",
        giftCardRecipient: "Recipient's name",
        giftCardRecipientEmail: "Recipient's email",
        giftCardMessage: "Message (optional)",
        giftCardDescription: "The best gift you can give someone special is the freedom to choose from the selection of brands and products available at Turkêsa Shop.",
        giftCardSelect: "Select",
        giftCardInstructions: "Choose the amount of your gift card, confirm payment with the method you prefer and receive it by email. Don't forget to visit our items to discover and share in person.",
        giftCardHowItWorksTitle: "How does it work?",
        giftCardStep1Title: "Choose the amount",
        giftCardStep1Desc: "Select the gift card amount you want to offer, between €30 and €300.",
        giftCardStep2Title: "Complete the purchase",
        giftCardStep2Desc: "Complete payment securely with the method you prefer.",
        giftCardStep3Title: "Receive by email",
        giftCardStep3Desc: "You will receive an email with the unique gift card code ready to use or give.",
        giftCardStep4Title: "Use in the store",
        giftCardStep4Desc: "Apply the code at checkout and the amount will be automatically deducted from the total purchase.",
        giftCardNote: "Our gift cards are valid for 6 months from the issue date and can be used on any Turkêsa Shop product.",

        // FAQ Page
        faqTitle: "Frequently Asked Questions",
        faqSubtitle: "Find answers to your questions",
        faqOrders: "Orders",
        faqPayments: "Payments",
        faqShipping: "Shipping",
        faqReturns: "Returns & Exchanges",
        faqQ1: "How do I pay for an order?",
        faqA1: "We accept Credit/Debit Card (Visa, Mastercard, American Express), PayPal, Apple Pay and Google Pay.",
        faqQ2: "Which countries does Turkesa Store ship to?",
        faqA2: "We ship to Mainland Portugal, the Islands, and countries in Europe. For international shipping, contact us.",
        faqQ3: "How much does delivery cost?",
        faqA3: "Shipping is free on orders over €50. Below that amount, it costs €5 for Mainland Portugal.",
        faqQ4: "How long does delivery take?",
        faqA4: "Delivery time is 1–2 business days for Mainland Portugal and 3–5 business days for the Islands.",
        faqQ5: "Can I exchange or return an item of clothing?",
        faqA5: "Yes, you have 14 days to return or exchange products. The item must be in perfect condition with original tags.",
        faqQ6: "What address should I send the order to in case of return?",
        faqA6: "Contact us by email and you will receive detailed instructions with the return address and label.",
        faqQ7: "How much does an exchange or return cost?",
        faqA7: "Return costs are the customer's responsibility. In case of exchange, shipping for the new item is free.",
        faqQ8: "Can I exchange a product?",
        faqA8: "Yes, we accept exchanges within 14 days. The product must be in perfect condition.",

        // Shipping Page
        shippingTitle: "Shipping",
        shippingSubtitle: "Information about delivery times and costs",
        shippingCostsTitle: "Shipping Costs",
        shippingDestination: "Destination",
        shippingCost: "Cost",
        shippingTime: "Time",
        shippingPortugal: "Continental Portugal",
        shippingFreeOver50: "Free over €50",
        shippingIslands: "Islands (Azores and Madeira)",
        shippingEurope: "Europe",
        shippingInternational: "Rest of World",
        shippingContact: "Contact",
        shipping3to5: "3-5 business days",
        shipping5to7: "5-7 business days",
        shipping7to15: "7-15 business days",
        shippingProcessingTitle: "Order Processing",
        shippingProcessingText: "Orders are processed Monday to Friday, from 10am to 6pm. Orders placed on weekends or holidays will be processed the next business day.",
        shippingProcessing1: "Orders until 2pm: shipped same day",
        shippingProcessing2: "Orders after 2pm: shipped next day",
        shippingProcessing3: "You will receive confirmation email with tracking number",
        shippingTrackingTitle: "Order Tracking",
        shippingTrackingText: "After your order is shipped, you will receive an email with the tracking number to follow your delivery status.",
        shippingIssuesTitle: "Delivery Problems?",
        shippingIssuesText: "If your order doesn't arrive on time or if there's any problem with delivery, contact us:",
        shippingPolicyTitle: "Shipping Policy",
        shippingPolicyIntro: "Turkesa entrusts the delivery of its orders to an external carrier, shipping the ordered product(s) on the days and times used by the logistics company, to the delivery address indicated.",
        shippingPolicyDeliveryTime: "Estimated delivery time varies between 1–2 business days for orders delivered in Mainland Portugal and 3–5 business days for orders delivered in the Azores or Madeira. Delivery times may vary during periods such as the Christmas season.",
        shippingPolicyCosts: "Shipping costs are the responsibility of the customer. Shipping has a variable cost depending on the order, except for orders of €155 or more, in which shipping is free and covered by Turkesa.",
        shippingPolicyResponsibility: "Turkesa is not responsible for any costs associated with possible customs clearance, which are the customer's responsibility.",
        shippingPolicyChecking: "The customer is responsible for checking the ordered product(s), as well as requesting a refund of the amount paid, within a maximum of 15 (fifteen) business days after being notified of unavailability.",
        shippingPolicyConfirmation: "Delivery is deemed completed upon signature of the delivery receipt at the agreed address.",

        // Returns Page
        returnsTitle: "Returns & Exchanges",
        returnsSubtitle: "Your satisfaction is our priority",
        returnsPolicyTitle: "Returns & Exchanges",
        returnsPolicyIntro: "The customer may proceed to exchange the item(s) 14 days after receiving them.",
        returnsPolicyConditions: "Provided that,",
        returnsPolicyCondition1: "The products have not been used;",
        returnsPolicyCondition2: "With the proper tags.",
        returnsPolicyShippingCost: "The cost of return shipping is the customer's responsibility.",
        returnsPolicyRefundNote: "Note that, if the return is made for reasons other than non-conformity of the ordered products, Turkêsa will not refund the shipping costs.",
        returnsPolicyIdentification: "You must also include your identification in the returned order, so that Turkêsa can analyze the state of conservation of the items, and after analysis, contact the customer.",
        returnsPolicyNote: "Note:",
        returnsPolicyDefect: "In case of defect, the shipping cost is covered up to the value of €5.",
        returnsPolicyReservations: "We do not make reservations.",

        // Terms Page
        termsTitle: "Terms and Conditions",
        termsLastUpdated: "Last updated: February 2026",
        termsSection1Title: "1. General Information",
        termsSection1Body: "Welcome to Turkesa. By accessing and using this website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you should not use our website.",
        termsSection2Title: "2. Company Information",
        termsCompanyNameLabel: "Name:",
        termsCompanyAddressLabel: "Address:",
        termsCompanyEmailLabel: "Email:",
        termsCompanyPhoneLabel: "Phone:",
        termsSection3Title: "3. Products and Prices",
        termsSection3Item1: "All products are subject to availability",
        termsSection3Item2: "The prices shown include VAT at the applicable legal rate",
        termsSection3Item3: "We reserve the right to change prices without prior notice",
        termsSection3Item4: "Product images are for illustrative purposes only",
        termsSection3Item5: "Products may show slight color variations due to your monitor settings",
        termsSection4Title: "4. Order Process",
        termsSection4Intro: "When placing an order, the customer:",
        termsSection4Item1: "Confirms that all information provided is true and accurate",
        termsSection4Item2: "Accepts these Terms and Conditions",
        termsSection4Item3: "Authorizes Turkesa to process their personal data",
        termsSection4Item4: "Receives an order confirmation email",
        termsSection5Title: "5. Payment",
        termsSection5Intro: "We accept the following payment methods:",
        termsSection5Item1: "Credit/Debit Card (Visa, Mastercard)",
        termsSection5Item2: "PayPal",
        termsSection5Item3: "Apple Pay",
        termsSection5Item4: "Bank Transfer",
        termsSection5Outro: "Payment must be made at the time of ordering. The order will only be processed after payment confirmation.",
        termsSection6Title: "6. Shipping and Delivery",
        termsSection6Item1: "Free shipping on orders over €150",
        termsSection6Item2: "Delivery time: 2–5 business days (Mainland Portugal)",
        termsSection6Item3: "Deliveries are made Monday to Friday",
        termsSection6Item4: "Someone must be present at the address to receive the order",
        termsSection6Item5: "In case of absence, a notice will be left for collection",
        termsSection7Title: "7. Right of Withdrawal",
        termsSection7Body1: "According to Portuguese law, the customer has the right to return the order within 14 days after receipt, without justification.",
        termsSection7Body2: "Conditions to exercise this right:",
        termsSection7Body3: "When returning an item, the customer must provide the tracking number supplied by the carrier so we can identify the returned order.",
        termsSection7Item1: "Products must be in perfect condition",
        termsSection7Item2: "With tags and original packaging",
        termsSection7Item3: "They must not have been used or washed",
        termsSection7Item4: "Return shipping costs are the customer's responsibility",
        termsSection8Title: "8. Warranties",
        termsSection8Body1: "All products sold benefit from a legal warranty of 2 years, according to Decree-Law no. 67/2003.",
        termsSection8Body2: "In case of manufacturing defect:",
        termsSection8Item1: "Contact us at turkesashop@gmail.com",
        termsSection8Item2: "Describe the problem and send photos if possible",
        termsSection8Item3: "Wait for instructions for return or repair",
        termsSection9Title: "9. Intellectual Property",
        termsSection9Body: "All content on this website, including texts, images, logos and design, is the property of Turkesa and is protected by copyright. Reproduction without prior authorization is prohibited.",
        termsSection10Title: "10. Limitation of Liability",
        termsSection10Intro: "Turkesa is not responsible for:",
        termsSection10Item1: "Delays in deliveries caused by carriers",
        termsSection10Item2: "Damages caused by improper use of products",
        termsSection10Item3: "Temporary unavailability of the website",
        termsSection10Item4: "Typographical or information errors",
        termsSection11Title: "11. Data Protection",
        termsSection11Body: "The collection and processing of personal data is described in our Privacy Policy. By using this website, you consent to the processing of your data as described.",
        termsSection12Title: "12. Dispute Resolution",
        termsSection12Body: "In case of dispute, the customer can resort to an Alternative Dispute Resolution entity for consumer disputes. For more information, see our Dispute Resolution page.",
        termsSection13Title: "13. Applicable Law",
        termsSection13Body: "These Terms and Conditions are governed by Portuguese law. Any dispute will be subject to the jurisdiction of Portuguese courts.",
        termsSection14Title: "14. Changes to the Terms",
        termsSection14Body: "Turkesa reserves the right to modify these Terms and Conditions at any time. Changes take effect immediately upon publication on the website.",
        termsSection15Title: "15. Contact",
        termsSection15Body: "For any questions related to these Terms and Conditions, contact us:",
        termsSection15ItemEmailLabel: "Email:",
        termsSection15ItemPhoneLabel: "Phone/WhatsApp:",
        termsSection15ItemAddressLabel: "Address:",

        // Privacy Page
        privacyTitle: "Privacy Policy and Cookies",
        privacyLastUpdated: "Last updated: January 2026",
        privacySection1Title: "1. Introduction",
        privacySection1Body: "Turkesa respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, store and protect your information when you visit our website or use our services.",
        privacySection2Title: "2. Data We Collect",
        privacySection2Intro: "We may collect and process the following personal data:",
        privacySection2Item1: "Identification information (name, email, phone number)",
        privacySection2Item2: "Delivery and billing address",
        privacySection2Item3: "Payment information (processed securely)",
        privacySection2Item4: "Purchase history and preferences",
        privacySection2Item5: "Browsing data (IP address, browser type, pages visited)",
        privacySection3Title: "3. How We Use Your Data",
        privacySection3Intro: "We use your personal data to:",
        privacySection3Item1: "Process and deliver your orders",
        privacySection3Item2: "Communicate about the status of your orders",
        privacySection3Item3: "Improve your shopping experience",
        privacySection3Item4: "Send newsletters and promotional offers (with your consent)",
        privacySection3Item5: "Comply with legal obligations",
        privacySection4Title: "4. Cookies",
        privacySection4Intro: "Our website uses cookies to improve your browsing experience. Cookies are small text files stored on your device that help us to:",
        privacySection4Item1: "Remember your preferences and settings",
        privacySection4Item2: "Keep your login session",
        privacySection4Item3: "Analyze website traffic",
        privacySection4Item4: "Personalize content and ads",
        privacySection4Outro: "You can manage your cookie preferences through your browser settings.",
        privacySection5Title: "5. Data Sharing",
        privacySection5Intro: "Turkesa does not sell your personal data to third parties. We may share your information with:",
        privacySection5Item1: "Payment service providers",
        privacySection5Item2: "Shipping and delivery companies",
        privacySection5Item3: "Technology service providers",
        privacySection5Outro: "All these entities are required to protect your data and use it only for the specified purposes.",
        privacySection6Title: "6. Data Security",
        privacySection6Body: "We implement technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure or destruction.",
        privacySection7Title: "7. Your Rights",
        privacySection7Intro: "Under the GDPR, you have the right to:",
        privacySection7Item1: "Access your personal data",
        privacySection7Item2: "Rectify incorrect or incomplete data",
        privacySection7Item3: "Request deletion of your data",
        privacySection7Item4: "Object to the processing of your data",
        privacySection7Item5: "Request data portability",
        privacySection7Item6: "Withdraw consent at any time",
        privacySection8Title: "8. Data Retention",
        privacySection8Body: "We keep your personal data only as long as necessary to fulfill the purposes described in this policy or as required by law.",
        privacySection9Title: "9. Contact",
        privacySection9Intro: "For questions about this Privacy Policy or to exercise your rights, contact us:",
        privacySection9ItemEmailLabel: "Email:",
        privacySection9ItemPhoneLabel: "Phone:",
        privacySection9ItemAddressLabel: "Address:",
        privacySection10Title: "10. Changes to This Policy",
        privacySection10Body: "We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page with the update date.",

        // Dispute Resolution Page
        litigiosTitle: "Alternative Dispute Resolution",
        litigiosSection1Title: "Information for Consumers",
        litigiosSection1Body: "According to Law no. 144/2015 of September 8, we inform that in case of dispute, the consumer may resort to an Alternative Dispute Resolution entity for consumer disputes.",
        litigiosSection2Title: "What is Alternative Dispute Resolution?",
        litigiosSection2Body: "Alternative Dispute Resolution (ADR) is an out-of-court procedure that allows consumers and merchants to resolve conflicts in a simple, fast, informal and free or low-cost way.",
        litigiosSection3Title: "How does it work?",
        litigiosSection3Body: "In case of dispute, the consumer can submit a complaint to one of the ADR entities for consumer disputes. These entities are impartial and can help resolve the conflict through mediation, conciliation or arbitration.",
        litigiosSection4Title: "Alternative Dispute Resolution Entities",
        litigiosSection4Intro: "For more information, visit the Consumer Portal at:",
        litigiosSection4SubTitle: "Main ADR Entities in Portugal:",
        litigiosLabelWebsite: "Website:",
        litigiosLabelEmail: "Email:",
        litigiosLabelPhone: "Phone:",
        litigiosSection5Title: "European Online Dispute Resolution Platform",
        litigiosSection5Body: "For cross-border disputes, consumers can use the European Online Dispute Resolution platform:",
        litigiosSection6Title: "Complaints Book",
        litigiosSection6Body: "You can also submit your complaint through the Electronic Complaints Book:",
        litigiosSection7Title: "Contact Us First",
        litigiosSection7Body: "Before contacting a dispute resolution entity, we recommend that you contact us so we can try to resolve any issue amicably:",
        litigiosSection7ItemEmailLabel: "Email:",
        litigiosSection7ItemPhoneLabel: "Phone/WhatsApp:",
        litigiosSection7ItemAddressLabel: "Address:",
        litigiosSection7Closing: "We are committed to resolving any issue quickly and satisfactorily.",

        // Discount Popup
        popupQuestion: "Do you want",
        popupDiscount: "5% OFF",
        popupSubtitle: "Your first order",
        popupEmailPlaceholder: "Enter your email",
        popupButtonYes: "Get my 5%",
        popupButtonNo: "NO, I WANT TO PAY FULL PRICE",
        popupSuccess: "Discount applied at checkout.",

        // Search Modal
        searchTitle: "What are you looking for?",
        searchPlaceholder: "Search products...",
        searchButton: "Search",
        searchPageTitle: "Product search",
        searchPageSubtitle: "Find the products you're looking for.",
        searchResultsLabel: "Results",
        searchResultsFor: "Results for",
        searchNoResultsTitle: "No products found",
        searchNoResultsText: "We couldn't find products for",
        searchNoResultsHint: "Try another term or check the spelling.",
        searchStartTitle: "Start searching",
        searchStartText: "Type a product name to get started."
    },

    es: {
        // Header
        announcementBar: "Envío gratis en pedidos superiores a 150€",

        // Navigation
        navNew: "Novedades",
        navCollection: "Colección",
        navBrands: "Marcas",
        navOutlet: "Outlet",

        // Hero
        heroTitle: "Experimenta el Lujo en Cada Detalle",
        heroSubtitle: "Colección Premium 2024",
        btnShopNow: "COMPRAR AHORA",
        heroViewCollection: "Ver colección",

        // Novidades Section
        novidadesTitle: "NOVEDADES",
        verTudo: "ver todo",
        btnView: "VER",
        productSoldOut: "AGOTADO",
        relatedTitle: "TAMBIÉN TE PUEDE GUSTAR",
        lastUnits: "ÚLTIMAS UNIDADES",

        // Brands Section
        brandsTitle: "Nuestra (Irresistible) Selección de Marcas",

        // About Section
        aboutSubtitle: "From Turkesa with love",
        aboutTitle: "Turkesa Shop",
        aboutText1: "El nombre \"Turkêsa\" surge de la inspiración en los mares de color azul turquesa. Transmite buena energía y nos transporta a paisajes paradisíacos.",
        aboutText2: "El objetivo de nuestra tienda es proporcionar a todas nuestras clientas la confianza, la belleza, el bienestar y la fuerza necesaria para enfrentar el día a día. Todas las mujeres son bonitas cuando se sienten bonitas. Turkêsa te hace sentir aún más bonita.",

        // Footer
        footerInfo: "Info",
        footerContactos: "Contacto",
        footerLojas: "Tiendas físicas",
        footerGiftCard: "Tarjeta regalo",
        footerFaq: "Preguntas frecuentes",
        footerEnvios: "Envíos",
        footerTrocas: "Devoluciones y cambios",

        footerPoliticas: "Políticas",
        footerTermos: "Términos y condiciones",
        footerPrivacidade: "Política de Privacidad y Cookies",
        footerLitigios: "Resolución de Litigios",
        footerReclamacoes: "Libro de Reclamaciones",

        // Cookie Banner
        cookieMessage: 'Este sitio web utiliza cookies para mejorar tu experiencia de navegación. Al continuar navegando, aceptas nuestra <a href="/pages/privacidade" style="color: var(--primary-color); text-decoration: underline;">Política de Privacidad y Cookies</a>.',
        cookieAccept: "Aceptar",
        cookieManage: "Gestionar Cookies",

        footerApoio: "Atención al Cliente",
        footerHorario: "Mar-Sáb: 10:00–13:00 / 14:30–18:00 | Dom-Lun: Cerrado",
        footerTelemovel: "Móvil & Whatsapp: 938 066 928",
        footerChamada: "(Llamada a red móvil nacional)",
        footerEmail: "Email: turkesashop@gmail.com",

        footerNewsletter: "Mantente al día con Turkesa",
        footerNewsletterText: "Suscríbete a nuestro boletín y recibe todas las novedades y campañas en tu email.",
        footerNome: "Nombre",
        footerEmailPlaceholder: "Email",
        footerSubscribe: "SUSCRIBIR",
        footerLegalText: "Este sitio está protegido por la Política de privacidad de hCaptcha y se aplican los Términos de servicio de hCaptcha",

        footerSocial: "Redes sociales",
        footerCopyright: "© Todos los derechos reservados 2026 . Turkêsa Shop . Impulsado por",

        // Cart
        cartTitle: "Carrito",
        cartEmpty: "Tu carrito está vacío",
        cartSubtotal: "Subtotal",
        cartTotal: "Total:",
        cartCheckout: "Finalizar Compra",
        cartDiscountLabel: "Descuento",
        cartDiscountCodeLabel: "Código de descuento",
        cartDiscountPlaceholder: "Introducir código",
        cartDiscountApply: "Aplicar",
        cartDiscountRemove: "Eliminar",
        cartDiscountApplied: "Código aplicado",
        cartDiscountInvalid: "Código inválido",
        cartDiscountEmpty: "Introduce un código",

        // Product Page
        productBreadcrumbInicio: "Inicio",
        productBreadcrumbMulher: "Mujer",
        productBreadcrumbVestidos: "Vestidos",
        productSize: "Talla",
        productSelectSize: "Selecciona la talla",
        productQuantity: "Cantidad",
        productAddToCart: "Añadir al Carrito",
        productDescription: "Descripción",
        productComposition: "Composición",
        productShipping1: "Entregas en 24h",
        productShipping2: "Envío gratis en pedidos superiores a 155€",
        productShipping3: "Devoluciones y cambios en 14 días",
        productPayments: "Pagos Seguros",

        // Login Page
        loginWelcome: "Bienvenida",
        loginSubtitle: "Inicia sesión en tu cuenta para continuar",
        loginEmail: "Email",
        loginEmailPlaceholder: "tu@email.com",
        loginPassword: "Contraseña",
        loginRememberMe: "Recordarme",
        loginForgotPassword: "¿Olvidaste tu contraseña?",
        loginButton: "Iniciar sesión",
        loginDivider: "o inicia sesión con",
        loginSignupText: "¿No tienes cuenta?",
        loginSignupLink: "Crear cuenta",
        loginAlready: "Ya has iniciado sesión.",
        loginGoAccount: "Ir a la cuenta",
        loginLogout: "Cerrar sesión",
        loginRecoverTitle: "Recuperar contraseña",
        loginRecoverSubtitle: "Te enviaremos un email para restablecer tu contraseña.",
        loginRecoverButton: "Enviar email",
        loginRecoverBack: "Volver al inicio de sesión",
        loginRecoverSuccess: "Te hemos enviado un email con instrucciones para restablecer tu contraseña.",
        loginRecoverCooldownPrefix: "Espera",
        loginRecoverCooldownSuffix: "para intentarlo de nuevo.",

        // Register Page
        registerTitle: "Crear cuenta",
        registerSubtitle: "Crea tu cuenta para seguir tus pedidos.",
        registerFirstName: "Nombre",
        registerLastName: "Apellido",
        registerEmail: "Email",
        registerEmailPlaceholder: "Email",
        registerPhone: "Teléfono móvil",
        registerPhonePlaceholder: "Número de móvil",
        registerPhoneHelp: "Usamos este numero para avisarte cuando tu pedido este listo para recogida.",
        registerPassword: "Contraseña",
        registerPasswordPlaceholder: "••••••••",
        registerPasswordConfirm: "Confirmar contraseña",
        registerDob: "Fecha de nacimiento",
        registerDobHint: "Solo lo usamos para enviarte tu descuento de cumpleaños.",
        registerCriteria1: "Mínimo 8 caracteres",
        registerCriteria2: "Al menos un número",
        registerCriteria3: "Al menos una letra mayúscula",
        registerCriteria4: "Al menos un carácter especial",
        registerPasswordMismatch: "Las contraseñas no coinciden",
        registerSubmit: "Crear cuenta",
        registerHaveAccount: "Ya tengo cuenta.",
        registerLoginLink: "Iniciar sesión",
        registerEmailExistsTitle: "Este email ya está asociado a una cuenta.",
        registerEmailExistsText: "Si la cuenta es tuya, puedes",
        registerEmailExistsCTA: "restablecer la contraseña aquí",

        // Account Page
        accountTitle: "Mi cuenta",
        accountLogout: "Cerrar sesión",
        accountPersonalInfo: "Información personal",
        accountNameLabel: "Nombre",
        accountEmailLabel: "Email",
        accountOrdersTitle: "Pedidos",
        accountOrderStatusProcessing: "En proceso",
        accountOrderStatusPending: "Pendiente",
        accountOrderStatusDelivered: "Entregado",
        accountOrderDateLabel: "Fecha:",
        accountOrderTotalLabel: "Total:",
        accountOrderDetailsLink: "Ver detalles",
        accountNoOrders: "Sin pedidos registrados.",

        // Order Page
        orderBackToAccount: "Volver a la cuenta",
        orderTitle: "Pedido",
        orderPlacedOn: "Realizado el",
        orderBillingAddress: "Dirección de facturación",
        orderShippingAddress: "Dirección de envío",
        orderPaymentStatus: "Estado del pago",
        orderFulfillmentStatus: "Estado del envío",
        orderItemsTitle: "Productos",
        orderProduct: "Producto",
        orderSku: "SKU",
        orderPrice: "Precio",
        orderQuantity: "Cantidad",
        orderLineTotal: "Total",
        orderSubtotal: "Subtotal",
        orderDiscount: "Descuento",
        orderShipping: "Envío",
        orderTax: "Impuestos",
        orderTotal: "Total",
        orderNoShippingAddress: "Sin dirección de envío.",
        orderStatusPaid: "Pagado",
        orderStatusPending: "Pendiente",
        orderStatusAuthorized: "Autorizado",
        orderStatusPartiallyPaid: "Parcialmente pagado",
        orderStatusPartiallyRefunded: "Parcialmente reembolsado",
        orderStatusRefunded: "Reembolsado",
        orderStatusVoided: "Anulado",
        orderStatusUnpaid: "No pagado",
        orderFulfillmentFulfilled: "Entregado",
        orderFulfillmentUnfulfilled: "No enviado",
        orderFulfillmentPartial: "Parcialmente enviado",
        orderFulfillmentRestocked: "Reabastecido",

        // Checkout Page
        checkoutTitle: "Finalizar Compra",
        checkoutContactInfo: "Información de Contacto",
        checkoutShippingInfo: "Información de Envío",
        checkoutFirstName: "Nombre",
        checkoutLastName: "Apellido",
        checkoutAddress: "Dirección",
        checkoutCity: "Ciudad",
        checkoutPostalCode: "Código Postal",
        checkoutCountry: "País",
        checkoutCountrySelect: "Selecciona un país",
        checkoutPhone: "Teléfono",
        checkoutPaymentMethod: "Método de Pago",
        checkoutCardName: "Nombre en la Tarjeta",
        checkoutCardInfo: "Información de la Tarjeta",
        checkoutOrderSummary: "Resumen del Pedido",
        checkoutQuantity: "Cantidad",
        checkoutSubtotal: "Subtotal",
        checkoutShipping: "Envío",
        checkoutTotal: "Total",
        checkoutFree: "Gratis",
        checkoutSecurePayment: "Pago Seguro",
        checkoutFastDelivery: "Entrega Rápida",
        checkoutCompleteOrder: "Finalizar Pedido",

        // Contacts Page
        contactsTitle: "Contacto",
        contactsHeroTitle: "¿NO ENCONTRASTE LO QUE BUSCABAS?",
        contactsHeroSubtitle: "SEA CUAL SEA TU DUDA, ESTAMOS AQUÍ PARA AYUDARTE.",
        contactsPhone: "Teléfono & WhatsApp",
        contactsEmail: "Email",
        contactsSchedule: "Horario de Atención",
        contactsScheduleLine1: "Martes a Sábado: 10:00–13:00 / 14:30–18:00",
        contactsScheduleLine2: "Domingo y Lunes: Cerrado",
        contactsAddress: "Dirección",
        contactsSocial: "Redes Sociales",
        contactsFormTitle: "Envíanos un mensaje",
        contactsName: "Nombre",
        contactsSubject: "Asunto",
        contactsMessage: "Mensaje",
        contactsSend: "Enviar",

        // Stores Page
        storesTitle: "Tiendas Físicas",
        storesSubtitle: "Visítanos en nuestras tiendas y descubre nuestras colecciones",
        storesLisbon: "Lisboa - Centro",
        storesPorto: "Oporto - Centro",
        storesFaro: "Faro - Marina",
        storesEspinho: "Tienda Espinho",

        // Gift Card Page
        giftCardTitle: "Tarjeta Regalo Turkesa",
        giftCardSubtitle: "El regalo perfecto para los amantes de la moda",
        giftCardHow: "¿Cómo funciona?",
        giftCardStep1: "Elige el valor de tu Tarjeta Regalo",
        giftCardStep2: "Personaliza con un mensaje especial",
        giftCardStep3: "Recibe por email o imprime en casa",
        giftCardStep4: "El destinatario puede usar online o en tienda",
        giftCardConditions: "Condiciones",
        giftCardCond1: "Válida por 12 meses después de la compra",
        giftCardCond2: "Se puede usar en múltiples compras",
        giftCardCond3: "No reembolsable",
        giftCardCond4: "Válida en todas las tiendas y online",
        giftCardSelectValue: "Selecciona el valor",
        giftCardRecipient: "Nombre del destinatario",
        giftCardRecipientEmail: "Email del destinatario",
        giftCardMessage: "Mensaje (opcional)",
        giftCardDescription: "El mejor regalo que puedes dar a alguien especial es la libertad de elegir entre la selección de marcas y productos que Turkêsa Shop pone a tu disposición.",
        giftCardSelect: "Seleccionar",
        giftCardInstructions: "Elige la cantidad de tu gift card, confirma el pago con el método que prefieras y recíbelo en tu email. No te olvides de visitar nuestros artículos para conocerlos y compartirlos en persona.",
        giftCardHowItWorksTitle: "¿Cómo funciona?",
        giftCardStep1Title: "Elige el valor",
        giftCardStep1Desc: "Selecciona la cantidad del gift card que deseas ofrecer, entre 30€ y 300€.",
        giftCardStep2Title: "Finaliza la compra",
        giftCardStep2Desc: "Completa el pago de forma segura con el método que prefieras.",
        giftCardStep3Title: "Recibe por email",
        giftCardStep3Desc: "Recibirás un email con el código único del gift card listo para usar o regalar.",
        giftCardStep4Title: "Úsalo en la tienda",
        giftCardStep4Desc: "Aplica el código en el checkout y el importe se descontará automáticamente del total de la compra.",
        giftCardNote: "Nuestros gift cards tienen una validez de 6 meses a partir de la fecha de emisión y se pueden usar en cualquier producto de Turkêsa Shop.",

        // FAQ Page
        faqTitle: "Preguntas Frecuentes",
        faqSubtitle: "Encuentra respuestas a tus dudas",
        faqOrders: "Pedidos",
        faqPayments: "Pagos",
        faqShipping: "Envíos",
        faqReturns: "Devoluciones e Intercambios",
        faqQ1: "¿Cómo se realiza el pago de un pedido?",
        faqA1: "Aceptamos tarjeta de crédito/débito (Visa, Mastercard, American Express), PayPal, Apple Pay y Google Pay.",
        faqQ2: "¿A qué países envía Turkesa Store?",
        faqA2: "Enviamos a Portugal Continental, las islas y países de Europa. Para envíos internacionales, contáctanos.",
        faqQ3: "¿Cuánto cuesta la entrega de un pedido?",
        faqA3: "El envío es gratis en compras superiores a 50€. Por debajo de ese importe, cuesta 5€ para Portugal Continental.",
        faqQ4: "¿Cuánto tarda la entrega de un pedido?",
        faqA4: "El plazo de entrega es de 1 a 2 días laborables para Portugal Continental y de 5 a 10 días laborables para las Islas.",
        faqQ5: "¿Puedo cambiar o devolver una prenda?",
        faqA5: "Sí, tienes 14 días para devolver o cambiar productos. El artículo debe estar en perfectas condiciones con las etiquetas originales.",
        faqQ6: "¿Cuál es la dirección a la que debo enviar el pedido en caso de devolución?",
        faqA6: "Ponte en contacto con nosotros por email y recibirás instrucciones detalladas con la dirección y la etiqueta de devolución.",
        faqQ7: "¿Cuánto cuesta un cambio o devolución de un pedido?",
        faqA7: "Los costes de devolución son responsabilidad del cliente. En caso de cambio, el envío del nuevo artículo es gratuito.",
        faqQ8: "¿Puedo cambiar un producto?",
        faqA8: "Sí, aceptamos cambios dentro del plazo de 14 días. El producto debe estar en perfectas condiciones.",

        // Shipping Page
        shippingTitle: "Envíos",
        shippingSubtitle: "Información sobre plazos y costes de envío",
        shippingCostsTitle: "Costes de Envío",
        shippingDestination: "Destino",
        shippingCost: "Coste",
        shippingTime: "Plazo",
        shippingPortugal: "Portugal Continental",
        shippingFreeOver50: "Gratis por encima de 50€",
        shippingIslands: "Islas (Azores y Madeira)",
        shippingEurope: "Europa",
        shippingInternational: "Resto del Mundo",
        shippingContact: "Contactar",
        shipping3to5: "3-5 días laborables",
        shipping5to7: "5-7 días laborables",
        shipping7to15: "7-15 días laborables",
        shippingProcessingTitle: "Procesamiento de Pedidos",
        shippingProcessingText: "Los pedidos se procesan de lunes a viernes, de 10h a 18h. Pedidos realizados en fin de semana o festivos serán procesados el próximo día laborable.",
        shippingProcessing1: "Pedidos hasta las 14h: enviados el mismo día",
        shippingProcessing2: "Pedidos después de las 14h: enviados al día siguiente",
        shippingProcessing3: "Recibirás email de confirmación con número de seguimiento",
        shippingTrackingTitle: "Seguimiento del Pedido",
        shippingTrackingText: "Después del envío de tu pedido, recibirás un email con el número de seguimiento para acompañar el estado de la entrega.",
        shippingIssuesTitle: "¿Problemas con la Entrega?",
        shippingIssuesText: "Si tu pedido no llega en el plazo previsto o si hay algún problema con la entrega, contacta con nosotros:",
        shippingPolicyTitle: "Política de envío",
        shippingPolicyIntro: "Turkesa confía la entrega de sus pedidos a un servicio de transporte externo, enviando el/los producto(s) solicitados en los días y horarios utilizados por la empresa de logística, a la dirección de entrega indicada.",
        shippingPolicyDeliveryTime: "El tiempo estimado de entrega varía entre 1 y 2 días laborables para pedidos con entrega en Portugal continental y 5 a 10 días laborables para pedidos con entrega en los archipiélagos de Azores o Madeira. Los plazos de envío pueden variar en periodos como la temporada navideña.",
        shippingPolicyCosts: "Los costes aplicados al envío del pedido son responsabilidad del cliente. El envío tiene un coste variable, dependiendo del pedido, salvo pedidos con un valor igual o superior a 155 €, en los que los portes son gratuitos y asumidos por Turkesa.",
        shippingPolicyResponsibility: "Turkesa no se responsabiliza de cualquier coste asociado a posibles trámites aduaneros, que quedan a cargo del cliente.",
        shippingPolicyChecking: "El cliente es responsable de verificar el/los producto(s) pedidos, así como de solicitar el reembolso del importe pagado, en un plazo máximo de 15 (quince) días laborables tras recibir el aviso de indisponibilidad.",
        shippingPolicyConfirmation: "La entrega se considera efectuada con la firma del recibo de entrega en la dirección acordada.",

        // Returns Page
        returnsTitle: "Devoluciones e Intercambios",
        returnsSubtitle: "Tu satisfacción es nuestra prioridad",
        returnsPolicyTitle: "Devoluciones e Intercambios",
        returnsPolicyIntro: "El cliente podrá proceder al cambio del/los artículo(s) 14 días después de recibirlos.",
        returnsPolicyConditions: "Siempre que,",
        returnsPolicyCondition1: "Los productos no hayan sido utilizados;",
        returnsPolicyCondition2: "Con las debidas etiquetas.",
        returnsPolicyShippingCost: "El coste del envío de la devolución es a cargo del cliente.",
        returnsPolicyRefundNote: "Note que, en caso de que la devolución se haga por otros motivos que no sean conformidad de los productos pedidos, Turkêsa no efectuará el reembolso de los portes de envío.",
        returnsPolicyIdentification: "Debe además colocar su identificación en el pedido devuelto, para que Turkêsa analice el estado de conservación de los artículos, y después del análisis, contacte con el cliente.",
        returnsPolicyNote: "Nota:",
        returnsPolicyDefect: "En caso de defecto, el valor de los portes está cubierto hasta el valor de 5€.",
        returnsPolicyReservations: "No efectuamos reservas.",

        // Terms Page
        termsTitle: "Términos y Condiciones",
        termsLastUpdated: "Última actualización: febrero de 2026",
        termsSection1Title: "1. Información General",
        termsSection1Body: "Bienvenido a Turkesa. Al acceder y utilizar este sitio web, aceptas estar vinculado a estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestro sitio web.",
        termsSection2Title: "2. Información de la Empresa",
        termsCompanyNameLabel: "Nombre:",
        termsCompanyAddressLabel: "Dirección:",
        termsCompanyEmailLabel: "Email:",
        termsCompanyPhoneLabel: "Teléfono:",
        termsSection3Title: "3. Productos y Precios",
        termsSection3Item1: "Todos los productos están sujetos a disponibilidad",
        termsSection3Item2: "Los precios mostrados incluyen IVA al tipo legal vigente",
        termsSection3Item3: "Nos reservamos el derecho de modificar precios sin previo aviso",
        termsSection3Item4: "Las imágenes de los productos son meramente ilustrativas",
        termsSection3Item5: "Los productos pueden presentar ligeras variaciones de color debido a la configuración de tu monitor",
        termsSection4Title: "4. Proceso de Pedido",
        termsSection4Intro: "Al realizar un pedido, el cliente:",
        termsSection4Item1: "Confirma que todos los datos proporcionados son verdaderos y correctos",
        termsSection4Item2: "Acepta los presentes Términos y Condiciones",
        termsSection4Item3: "Autoriza a Turkesa a procesar sus datos personales",
        termsSection4Item4: "Recibe un email de confirmación del pedido",
        termsSection5Title: "5. Pago",
        termsSection5Intro: "Aceptamos los siguientes métodos de pago:",
        termsSection5Item1: "Tarjeta de Crédito/Débito (Visa, Mastercard)",
        termsSection5Item2: "PayPal",
        termsSection5Item3: "Apple Pay",
        termsSection5Item4: "Transferencia Bancaria",
        termsSection5Outro: "El pago debe realizarse en el momento del pedido. El pedido solo será procesado tras la confirmación del pago.",
        termsSection6Title: "6. Envíos y Entregas",
        termsSection6Item1: "Envío gratis en compras superiores a 150€",
        termsSection6Item2: "Plazo de entrega: 2-5 días laborables (Portugal Continental)",
        termsSection6Item3: "Las entregas se realizan de lunes a viernes",
        termsSection6Item4: "Es necesario que haya alguien en el lugar para recibir el pedido",
        termsSection6Item5: "En caso de ausencia, se dejará un aviso para recogida",
        termsSection7Title: "7. Derecho de Desistimiento",
        termsSection7Body1: "De acuerdo con la legislación portuguesa, el cliente tiene derecho a devolver el pedido en un plazo de 14 días tras la recepción, sin necesidad de justificación.",
        termsSection7Body2: "Condiciones para ejercer este derecho:",
        termsSection7Body3: "Cuando el cliente devuelva el artículo, debe indicar el número de seguimiento proporcionado por la empresa de transportes para que podamos identificar el pedido devuelto.",
        termsSection7Item1: "Los productos deben estar en perfecto estado",
        termsSection7Item2: "Con etiquetas y embalaje original",
        termsSection7Item3: "No pueden haber sido usados ni lavados",
        termsSection7Item4: "El coste de la devolución es responsabilidad del cliente",
        termsSection8Title: "8. Garantías",
        termsSection8Body1: "Todos los productos comercializados se benefician de una garantía legal de 2 años, de acuerdo con el Decreto-Ley n.º 67/2003.",
        termsSection8Body2: "En caso de defecto de fabricación:",
        termsSection8Item1: "Contáctanos en turkesashop@gmail.com",
        termsSection8Item2: "Describe el problema y envía fotos si es posible",
        termsSection8Item3: "Espera instrucciones para devolución o reparación",
        termsSection9Title: "9. Propiedad Intelectual",
        termsSection9Body: "Todo el contenido de este sitio web, incluidos textos, imágenes, logotipos y diseño, es propiedad de Turkesa y está protegido por derechos de autor. Se prohíbe la reproducción sin autorización previa.",
        termsSection10Title: "10. Limitación de Responsabilidad",
        termsSection10Intro: "Turkesa no se responsabiliza por:",
        termsSection10Item1: "Retrasos en las entregas causados por las transportistas",
        termsSection10Item2: "Daños causados por el uso inadecuado de los productos",
        termsSection10Item3: "Indisponibilidad temporal del sitio web",
        termsSection10Item4: "Errores tipográficos o de información",
        termsSection11Title: "11. Protección de Datos",
        termsSection11Body: "La recogida y el tratamiento de datos personales se describen en nuestra Política de Privacidad. Al utilizar este sitio web, consientes el tratamiento de tus datos según lo descrito.",
        termsSection12Title: "12. Resolución de Litigios",
        termsSection12Body: "En caso de litigio, el cliente puede recurrir a una entidad de Resolución Alternativa de Litigios de consumo. Para más información, consulta nuestra página de Resolución de Litigios.",
        termsSection13Title: "13. Ley Aplicable",
        termsSection13Body: "Estos Términos y Condiciones se rigen por la ley portuguesa. Cualquier litigio será competencia de los tribunales portugueses.",
        termsSection14Title: "14. Cambios en los Términos",
        termsSection14Body: "Turkesa se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en el sitio web.",
        termsSection15Title: "15. Contacto",
        termsSection15Body: "Para cualquier cuestión relacionada con estos Términos y Condiciones, contáctanos:",
        termsSection15ItemEmailLabel: "Email:",
        termsSection15ItemPhoneLabel: "Teléfono/WhatsApp:",
        termsSection15ItemAddressLabel: "Dirección:",

        // Privacy Page
        privacyTitle: "Política de Privacidad y Cookies",
        privacyLastUpdated: "Última actualización: enero de 2026",
        privacySection1Title: "1. Introducción",
        privacySection1Body: "Turkesa respeta tu privacidad y está comprometida con proteger tus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información cuando visitas nuestro sitio web o utilizas nuestros servicios.",
        privacySection2Title: "2. Datos que Recopilamos",
        privacySection2Intro: "Podemos recopilar y procesar los siguientes datos personales:",
        privacySection2Item1: "Información de identificación (nombre, email, número de teléfono)",
        privacySection2Item2: "Dirección de entrega y facturación",
        privacySection2Item3: "Información de pago (procesada de forma segura)",
        privacySection2Item4: "Historial de compras y preferencias",
        privacySection2Item5: "Datos de navegación (dirección IP, tipo de navegador, páginas visitadas)",
        privacySection3Title: "3. Cómo Utilizamos Tus Datos",
        privacySection3Intro: "Utilizamos tus datos personales para:",
        privacySection3Item1: "Procesar y entregar tus pedidos",
        privacySection3Item2: "Comunicar sobre el estado de tus pedidos",
        privacySection3Item3: "Mejorar tu experiencia de compra",
        privacySection3Item4: "Enviar newsletters y ofertas promocionales (con tu consentimiento)",
        privacySection3Item5: "Cumplir obligaciones legales",
        privacySection4Title: "4. Cookies",
        privacySection4Intro: "Nuestro sitio web utiliza cookies para mejorar tu experiencia de navegación. Las cookies son pequeños archivos de texto almacenados en tu dispositivo que nos ayudan a:",
        privacySection4Item1: "Recordar tus preferencias y ajustes",
        privacySection4Item2: "Mantener tu sesión de inicio",
        privacySection4Item3: "Analizar el tráfico del sitio web",
        privacySection4Item4: "Personalizar el contenido y los anuncios",
        privacySection4Outro: "Puedes gestionar tus preferencias de cookies a través de la configuración de tu navegador.",
        privacySection5Title: "5. Compartición de Datos",
        privacySection5Intro: "Turkesa no vende tus datos personales a terceros. Podemos compartir tu información con:",
        privacySection5Item1: "Proveedores de servicios de pago",
        privacySection5Item2: "Empresas de transporte y entrega",
        privacySection5Item3: "Proveedores de servicios tecnológicos",
        privacySection5Outro: "Todas estas entidades están obligadas a proteger tus datos y utilizarlos únicamente para los fines especificados.",
        privacySection6Title: "6. Seguridad de los Datos",
        privacySection6Body: "Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos personales contra el acceso no autorizado, la alteración, la divulgación o la destrucción.",
        privacySection7Title: "7. Tus Derechos",
        privacySection7Intro: "De acuerdo con el RGPD, tienes derecho a:",
        privacySection7Item1: "Acceder a tus datos personales",
        privacySection7Item2: "Rectificar datos incorrectos o incompletos",
        privacySection7Item3: "Solicitar la eliminación de tus datos",
        privacySection7Item4: "Oponerte al tratamiento de tus datos",
        privacySection7Item5: "Solicitar la portabilidad de tus datos",
        privacySection7Item6: "Retirar tu consentimiento en cualquier momento",
        privacySection8Title: "8. Retención de Datos",
        privacySection8Body: "Conservamos tus datos personales solo el tiempo necesario para cumplir los objetivos descritos en esta política o según lo exija la ley.",
        privacySection9Title: "9. Contacto",
        privacySection9Intro: "Para cuestiones sobre esta Política de Privacidad o para ejercer tus derechos, contáctanos:",
        privacySection9ItemEmailLabel: "Email:",
        privacySection9ItemPhoneLabel: "Teléfono:",
        privacySection9ItemAddressLabel: "Dirección:",
        privacySection10Title: "10. Cambios en Esta Política",
        privacySection10Body: "Nos reservamos el derecho de actualizar esta Política de Privacidad periódicamente. Cualquier cambio se publicará en esta página con la fecha de actualización.",

        // Dispute Resolution Page
        litigiosTitle: "Resolución Alternativa de Litigios",
        litigiosSection1Title: "Información al Consumidor",
        litigiosSection1Body: "De acuerdo con la Ley n.º 144/2015, de 8 de septiembre, informamos que, en caso de litigio, el consumidor puede recurrir a una entidad de Resolución Alternativa de Litigios de consumo.",
        litigiosSection2Title: "¿Qué es la Resolución Alternativa de Litigios?",
        litigiosSection2Body: "La Resolución Alternativa de Litigios (RAL) es un procedimiento extrajudicial que permite a consumidores y comerciantes resolver sus conflictos de forma sencilla, rápida, informal y gratuita o de bajo costo.",
        litigiosSection3Title: "¿Cómo funciona?",
        litigiosSection3Body: "En caso de litigio, el consumidor puede presentar su reclamación ante una de las entidades de resolución alternativa de litigios de consumo. Estas entidades son imparciales y pueden ayudar a resolver el conflicto mediante mediación, conciliación o arbitraje.",
        litigiosSection4Title: "Entidades de Resolución Alternativa de Litigios",
        litigiosSection4Intro: "Para más información, consulte el Portal del Consumidor en:",
        litigiosSection4SubTitle: "Principales Entidades RAL en Portugal:",
        litigiosLabelWebsite: "Sitio web:",
        litigiosLabelEmail: "Email:",
        litigiosLabelPhone: "Teléfono:",
        litigiosSection5Title: "Plataforma Europea de Resolución de Litigios en Línea",
        litigiosSection5Body: "Para litigios transfronterizos, los consumidores pueden recurrir a la Plataforma Europea de Resolución de Litigios en Línea:",
        litigiosSection6Title: "Libro de Reclamaciones",
        litigiosSection6Body: "También puedes presentar tu reclamación a través del Libro de Reclamaciones Electrónico:",
        litigiosSection7Title: "Contáctanos Primero",
        litigiosSection7Body: "Antes de recurrir a una entidad de resolución de litigios, recomendamos que te pongas en contacto con nosotros para intentar resolver cualquier cuestión de forma amistosa:",
        litigiosSection7ItemEmailLabel: "Email:",
        litigiosSection7ItemPhoneLabel: "Teléfono/WhatsApp:",
        litigiosSection7ItemAddressLabel: "Dirección:",
        litigiosSection7Closing: "Estamos comprometidos a resolver cualquier problema de forma rápida y satisfactoria.",

        // Discount Popup
        popupQuestion: "¿Quieres",
        popupDiscount: "5% OFF",
        popupSubtitle: "En tu primer pedido",
        popupEmailPlaceholder: "Ingresa tu email",
        popupButtonYes: "Obtener mi 5%",
        popupButtonNo: "NO, PREFIERO PAGAR EL PRECIO COMPLETO",
        popupSuccess: "Descuento aplicado en el checkout.",

        // Search Modal
        searchTitle: "¿Qué buscas?",
        searchPlaceholder: "Buscar productos...",
        searchButton: "Buscar",
        searchPageTitle: "Búsqueda de productos",
        searchPageSubtitle: "Encuentra los productos que buscas.",
        searchResultsLabel: "Resultados",
        searchResultsFor: "Resultados para",
        searchNoResultsTitle: "No se encontraron productos",
        searchNoResultsText: "No encontramos productos para",
        searchNoResultsHint: "Prueba otro término o revisa la ortografía.",
        searchStartTitle: "Empieza a buscar",
        searchStartText: "Escribe el nombre de un producto para comenzar."
    }
};
